import styled, { css } from 'styled-components';
import { t } from '../Table.styles';
import { useState } from 'react';
import MoreButton from '../../../components/moreButton/MoreButton';

const BiddingHistory = ({ bidHistory }: any) => {
  const [showAll, setShowAll] = useState(false);
  const bidHistoryArray = JSON.parse(bidHistory).slice(1);
  const reversedData = bidHistoryArray.slice().reverse();

  return (
    <Container id="입찰이력">
      <Title>입찰이력</Title>

      <Content>
        <Item>
          <ItemContent>
            <span style={{ width: '68px', paddingLeft: '14px' }}>
              회차/차수
              <br />
              입찰번호
            </span>
            <span style={{ width: '111px' }}>
              처분방식
              <br />
              개찰일시
            </span>
          </ItemContent>
          <span style={{ flex: 1 }}>
            최저매각가격
            <br />
            결과
          </span>
        </Item>
        <Divider />

        {reversedData
          .slice(0, showAll ? bidHistoryArray.length : 3)
          .map((item: any, index: number) => (
            <>
              <Item key={index}>
                <ItemContent>
                  <Dot isFirst={index === 0} />
                  <Degree isFirst={index === 0}>
                    {item[1]} <br />
                    {item[0]}
                  </Degree>
                </ItemContent>
                <ItemContent>
                  <Date isFirst={index === 0}>
                    매각 <br />
                    {item[5]}
                  </Date>
                </ItemContent>
                <Result result={item[8]} isFirst={index === 0}>
                  <span>{item.length > 9 ? item[9] : item[7]} 원</span>
                  <br />
                  {item[8]}
                </Result>
              </Item>
              <Divider />
            </>
          ))}
        {bidHistoryArray.length > 3 && (
          <MoreButton
            name="입찰이력"
            showAll={showAll}
            setShowAll={setShowAll}
            sectionId="입찰이력"
          />
        )}
      </Content>
    </Container>
  );
};
export default BiddingHistory;

const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  /* justify-content: space-between; */

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: end;
  color: #616161;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  text-align: left;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f3f5f7;
`;

const Dot = styled.div<{ isFirst?: boolean }>`
  width: 6px;
  height: 6px;
  aspect-ratio: 1/1;
  background-color: ${({ isFirst }) => (isFirst ? '#008AFF' : '#37383C29')};
  border-radius: 9999px;
`;

const Degree = styled.div<{ isFirst?: boolean }>`
  font-weight: 500;
  font-size: 14px;
  color: ${({ isFirst }) => (isFirst ? '#222' : '#6B7684')};
  width: 54px;
`;

const Date = styled(Degree)`
  width: auto;
`;

const Result = styled.div<{ result?: string; isFirst: boolean }>`
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  ${({ result }) => {
    switch (result) {
      case '매각':
        return css`
          color: #008aff;
        `;
      case '유찰':
        return css`
          color: #f45551;
        `;
      case '진행':
        return css`
          color: #489f68;
        `;
      default:
        return css`
          color: #37383c9c;
        `;
    }
  }}

  span {
    color: ${({ result, isFirst }) =>
      result !== '매각' && isFirst ? '#222' : '#37383c9c'};
  }
`;
